<template>
  <div
    style="white-space: nowrap"
    :style="{
      width: cardSizeReactive[0] - 2 + 'px',
      height: cardSizeReactive[1] - 2 + 'px',
      backgroundColor: getTileColor(campaignType),
    }"
    class="flex flex-col"
  >
    <div class="h-15 w-95">
      <p v-multi-ref:resize style="font-weight: 700">
        {{ removeDot(agent.agentName).toUpperCase() }}
      </p>
    </div>
    <div class="h-15 w-95">
      <p v-multi-ref:resize>{{ agent.campaign }}</p>
    </div>
    <div class="h-45 w-full">
      <div
        class="h-full w-full"
        :style="{ maxHeight: detailHeight }"
        v-if="showIcon"
      >
        <font-awesome-icon
          v-multi-ref:resize
          :style="{ color: this.textColor }"
          :icon="faIcon(agent.agentStateNum)"
        />
      </div>
      <div
        v-if="showWrap"
        class="h-full w-full"
        :style="{ maxHeight: detailHeight }"
      >
        <p style="font-weight: 700" v-multi-ref:resize>
          Wrap: {{ agent.wrapPercent }}
        </p>
      </div>
      <div class="h-full w-full" :style="{ maxHeight: detailHeight }">
        <p style="font-weight: 700" v-multi-ref:resize>
          {{ agent.totalCalls }} calls (I:{{ agent.totalInbound }}/O:
          {{ agent.totalOutbound }})
        </p>
      </div>
    </div>

    <div class="h-25 w-full" :style="'background-color:' + colorReactive">
      <p v-multi-ref:resize>{{ toHMS(timeInState) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullState: Boolean,
    agentInfo: Object,
    inboundColor: String,
    cardSize: Array,
    color: String,
    campaignType: Number,
    showIcon: Boolean,
    showWrap: Boolean,
    resize: Boolean,
  },

  watch: {
    cardSizeReactive() {
      this.$nextTick(() => {
        this.resizeText({
          elements: this.$refs.resize,
        });
      });
    },

    resize(val) {
      if (val) {
        this.$nextTick(() => {
          this.resizeText({
            elements: this.$refs.resize,
          });
          this.$emit("resized");
        });
      }
    },
  },

  computed: {
    detailHeight() {
      var sectionCount = [this.showIcon, this.showWrap, true].filter(
        Boolean
      ).length; // hardcoded true value represents call count
      return 100 / sectionCount + "%";
    },

    agent() {
      return this.agentInfo;
    },

    cardSizeReactive() {
      return this.cardSize;
    },

    colorReactive() {
      if (!this.color) return;
      return this.color;
    },

    textColor() {
      if (this.fullState) return "#2c3e50";
      return this.colorReactive;
    },

    timeInState() {
      var date = new Date(Date.parse(this.agent.timestampCurrentState));
      var diff = this.now - date;
      return diff;
    },
  },

  mounted() {
    this.$nextTick(() => {
      let els = this.hasOverflown({ elements: this.$refs.resize });
      if (els.length == 0) return;
      this.resizeText({
        elements: els,
      });
      this.$emit("resized");
    });
  },

  updated() {
    let els = this.hasOverflown({ elements: this.$refs.resize });
    if (els.length == 0) return;
    this.resizeText({
      elements: els,
    });
  },

  methods: {
    getTileColor(campaign) {
      if (this.fullState) {
        return this.colorReactive;
      }
      if (campaign == 1) {
        return this.inboundColor;
      }
      return "#ffffff";
    },

    faIcon(agentState) {
      if (agentState == 0) return ["fas", "sign-out-alt"];
      if (agentState == 1) return ["fas", "pause-circle"];
      if (agentState == 2) return ["fas", "ban"];
      if (agentState == 3) return ["fas", "hourglass-half"];
      if (agentState == 4) return ["fas", "search"];
      if (agentState == 5) return ["fas", "wind"];
      if (agentState == 6) return ["fas", "phone"];
      if (agentState == 7) return ["fas", "phone-slash"];
      if (agentState == 9) return ["fas", "keyboard"];
      if (agentState == 10) return ["fas", "exchange-alt"];
      if (agentState == 11) return ["fas", "clock"];
      if (agentState == 12) return ["fas", "headset"];
      if (agentState == 15) return ["fas", "asterisk"];
      if (agentState == 16) return ["fas", "eye-slash"];
      if (agentState == 17) return ["fas", "microphone-alt-slash"];
    },

    removeDot(name) {
      return name.replaceAll(".", " ");
    },
  },
};
</script>

<style scoped>
.agent-card {
  border: 1px solid rgba(0, 0, 0, 0.3);
  margin: 0;
  padding: 0;
  text-align: center;
}

.h-15 {
  height: 15%;
}

.h-45 {
  height: 45%;
}

.h-25 {
  height: 25%;
}

.w-95 {
  width: 95%;
}

.mx--5 {
  margin: 0 -5%;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-col {
  flex-direction: column;
}
</style>